import { render, staticRenderFns } from "./SPaginationComp.vue?vue&type=template&id=d5eb789c&"
import script from "./SPaginationComp.vue?vue&type=script&lang=js&"
export * from "./SPaginationComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports